import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';
import { useTheme } from 'app/shopify';
import { Trans } from 'react-i18next';
import { Pressable } from 'react-native';
import { UserTypeProIcon } from './user-type-pro-icon';
import { UserTypePublic } from './user-type-public-icon';

export const ChooseUserTypeButton = ({
  userType,
  backgroundColor,
  foregroundColor,
  onPress,
}: {
  userType: string;
  backgroundColor: string;
  foregroundColor: string;
  onPress: () => void;
}) => {
  const theme = useTheme();
  const { t } = useScopedTranslation();
  return (
    <Pressable onPress={onPress}>
      <Column
        gap="spacing.general.x4"
        style={{
          backgroundColor,
          borderRadius: theme.borderRadii['radius.xl'],
          padding: theme.spacing['spacing.general.x4'],
        }}
      >
        <Row alignItems="center" gap="spacing.general.x4">
          {userType === 'pro' ? <UserTypeProIcon /> : userType === 'public' ? <UserTypePublic /> : null}
          <Text flex={1} style={{ color: foregroundColor }}>
            <Trans
              components={{ strong: <Text fontWeight="700" /> }}
              i18nKey={`type.desc.${userType}`}
              ns="chooseUserType"
            />
          </Text>
        </Row>
        <Column
          alignItems="center"
          style={{
            height: 56,
            borderRadius: 28,
            backgroundColor: foregroundColor,
            paddingHorizontal: theme.spacing['spacing.general.x6'],
            paddingVertical: theme.spacing['spacing.general.x4'],
          }}
        >
          <Text fontWeight="700" style={{ color: backgroundColor }} variant="headerXSmall">
            {t(`type.button.${userType}`)} →
          </Text>
        </Column>
      </Column>
    </Pressable>
  );
};
